import React from 'react';
import { Text, StyleProp, TextStyle, TouchableOpacity, ViewStyle, Pressable, View } from 'react-native';
import { FontInfo } from '../~Utilities/Constants';

interface IBlackHeader
{
sText: string,
sAddText: string
}

/*   ====================================================================   */

export default class BlackHeader extends React.Component<IBlackHeader>
 {
   state = {
      text:"",
      add_text:"",
   }

   /*   ------------------------------------------------------------------   */

   constructor(props)
   {
   super(props);

   this.state = {text:this.props.sText, add_text:this.props.sAddText};
   }

   /*   ------------------------------------------------------------------   */

   UpdateText(sText: string, sAddText: string)
   {
   if (this.state.text != sText || this.state.add_text != sAddText)
      this.setState({text:sText, add_text:sAddText});
   }

   /*   ------------------------------------------------------------------   */

   render() 
   {
   return(
      <View style={{flexDirection:'row'}}>
      <Text style={[FontInfo.appStyles.txt_black, 
                     {alignSelf: 'center',
                      display:this.state.add_text? 'none' : 'flex',
                      fontSize: FontInfo.iFontSize + 8,
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',}]}>
         {this.state.text}</Text>
      <Text style={[FontInfo.appStyles.txt_black, 
                     {alignSelf: 'center',
                      fontSize: FontInfo.iFontSize + 8,
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',}]}>
         {this.state.add_text}</Text>         
      </View>
      );
   }
}